import { createFileRoute } from '@tanstack/react-router';

import { DistHistoryView } from '../../raporty/dist-history/DistHistoryView';

export const Route = createFileRoute('/raporty/historia-dystrybucji')({
  component: DistHistoryView,
});
